<template>
  <div>
    <header class="tech-header fixed w-full top-0 z-50">
      <!-- 背景装饰 -->
      <div class="tech-bg"></div>
      <div class="tech-glow"></div>
      <div class="tech-grid"></div>

      <div class="container mx-auto px-4">
        <div class="header-content flex justify-between items-center py-4 relative">
          <!-- Logo -->
          <div class="logo-container flex items-center space-x-3">
            <img :src="require('@/assets/4.png')" alt="chmura云" class="logo" />
            <span class="logo-text">云，您的智慧选择</span>
          </div>

          <!-- 桌面导航 -->
          <div class="nav-container">
            <el-menu class="desktop-nav" mode="horizontal" background-color="transparent" text-color="#fff" active-text-color="#409EFF" :default-active="activeIndex" @select="handleSelect">
              <el-menu-item index="/">
                <router-link to="/">首页</router-link>
              </el-menu-item>
              <el-menu-item index="/services">
                <router-link to="/services">解决方案与产品</router-link>
              </el-menu-item>
              <el-menu-item index="/products">
                <router-link to="/products">产品查询</router-link>
              </el-menu-item>
              <el-menu-item index="/partner">
                <router-link to="/partner">合作伙伴</router-link>
              </el-menu-item>
              <el-menu-item index="/about">
                <router-link to="/about">关于云</router-link>
              </el-menu-item>
              <el-menu-item index="/contact">
                <router-link to="/contact">联系我们</router-link>
              </el-menu-item>
            </el-menu>
          </div>

          <!-- 移动端菜单按钮 -->
          <div class="mobile-menu-container">
            <div class="tech-menu-btn" @click="toggleMobileMenu">
              <div class="menu-btn-content">
                <span class="hamburger-icon"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- 移动端菜单（纯HTML实现） -->
    <div :class="{ 'mobile-menu-overlay': true, active: showMobileMenu }" @click="toggleMobileMenu"></div>
    <div :class="{ 'mobile-menu': true, active: showMobileMenu }">
      <div class="mobile-menu-header">

        <div class="mobile-menu-close" @click="toggleMobileMenu">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="mobile-menu-list">
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/' }" @click="handleMenuClick('/')">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </div>
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/services' }" @click="handleMenuClick('/services')">
          <i class="el-icon-s-grid"></i>
          <span>解决方案与产品</span>
        </div>
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/products' }" @click="handleMenuClick('/products')">
          <i class="el-icon-search"></i>
          <span>产品查询</span>
        </div>
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/partner' }" @click="handleMenuClick('/partner')">
          <i class="el-icon-s-cooperation"></i>
          <span>合作伙伴</span>
        </div>
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/about' }" @click="handleMenuClick('/about')">
          <i class="el-icon-info"></i>
          <span>关于云</span>
        </div>
        <div class="mobile-menu-item" :class="{ active: activeIndex === '/contact' }" @click="handleMenuClick('/contact')">
          <i class="el-icon-s-claim"></i>
          <span>联系我们</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      showMobileMenu: false,
      activeIndex: this.$route.path
    };
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
    },
    handleMenuClick(path) {
      this.$router.push(path);
      this.showMobileMenu = false;
      const menuBtn = document.querySelector('.tech-menu-btn');
      if (menuBtn) {
        menuBtn.classList.remove('active');
      }
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      const menuBtn = document.querySelector('.tech-menu-btn');
      if (menuBtn) {
        menuBtn.classList.toggle('active');
      }
    },
    handleImageError(error) {
      console.error('图片加载失败:', error);
    },
    handleImageLoad(event) {
      console.log('图片加载成功:', event);
    }
  }
};
</script>

<style scoped>
/* 基础容器样式 */
.tech-header {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  overflow: hidden;
  height: 80px;
  z-index: 9999 !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

/* 背景装饰 */
.tech-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f7f6 0%, #0a1128 100%);
  z-index: -2;
}

.tech-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 1200px;
  background: radial-gradient(circle, rgba(64, 158, 255, 0.1) 0%, transparent 70%);
  z-index: -1;
  animation: pulse 8s ease-in-out infinite;
}

.tech-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(64, 158, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(64, 158, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  z-index: -1;
  animation: gridMove 20s linear infinite;
}

/* 布局容器 */
.header-content {
  height: 100%;
}

.logo-container {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
}

.nav-container {
  display: flex;
  align-items: center;
}

.mobile-menu-container {
  display: flex;
  align-items: center;
}

/* Logo样式 */
.logo {
  width: 63px !important;
  height: 53px !important;
  border-radius: 8px;

  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo:hover {
  transform: scale(1.05);
  box-shadow: 0 0 30px rgba(64, 158, 255, 0.5);
}

.image-placeholder,
.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #409eff;
  font-size: 12px;
  background-color: rgba(64, 158, 255, 0.1);
}

.image-placeholder i,
.image-error i {
  margin-right: 4px;
}

.logo-text {
  font-size: 1.75rem;
  font-weight: bold;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #0284c7 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: textGlow 3s ease-in-out infinite alternate;
}

/* 桌面导航样式 */
.desktop-nav {
  border-bottom: none !important;
  background-color: transparent !important;
  height: 100%;
}

.desktop-nav .el-menu-item {
  position: relative;
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.3s ease;
  font-weight: 500;
  height: 72px !important;
  line-height: 72px !important;
  background-color: transparent !important;
}

.desktop-nav .el-menu-item:hover {
  color: #409eff !important;
  background-color: rgba(64, 158, 255, 0.1) !important;
}

.desktop-nav .el-menu-item.is-active {
  color: #409eff !important;
  font-weight: bold !important;
}

.desktop-nav .el-menu-item.is-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  /* background: linear-gradient(90deg, #409eff 0%, #67c23a 100%); */
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
}

/* 移动端菜单按钮 */
.tech-menu-btn {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.2) 0%, rgba(103, 194, 58, 0.2) 100%);
  border: 1px solid rgba(64, 158, 255, 0.4);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.3), inset 0 0 20px rgba(64, 158, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.tech-menu-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.tech-menu-btn:hover::before {
  left: 100%;
}

.tech-menu-btn:hover {
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.3) 0%, rgba(103, 194, 58, 0.3) 100%);
  border-color: rgba(64, 158, 255, 0.8);
  box-shadow: 0 0 30px rgba(64, 158, 255, 0.6), inset 0 0 20px rgba(64, 158, 255, 0.2);
  transform: scale(1.05);
}

.tech-menu-btn:active {
  transform: scale(0.95);
}

.menu-btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hamburger-icon {
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hamburger-icon::before,
.hamburger-icon::after,
.hamburger-icon span {
  content: '';
  position: absolute;
  width: 20px;
  height: 2px;
  background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.8);
  transition: all 0.3s ease;
  border-radius: 1px;
}

.hamburger-icon::before {
  top: 5px;
}

.hamburger-icon::after {
  bottom: 5px;
}

.hamburger-icon span {
  top: 50%;
  transform: translateY(-50%);
}

/* 按钮点击动画 */
.tech-menu-btn.active .hamburger-icon::before {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.tech-menu-btn.active .hamburger-icon::after {
  bottom: 50%;
  transform: translateY(50%) rotate(-45deg);
}

.tech-menu-btn.active .hamburger-icon span {
  opacity: 0;
  transform: translateX(-10px);
}

.tech-menu-btn:hover .hamburger-icon::before,
.tech-menu-btn:hover .hamburger-icon::after,
.tech-menu-btn:hover .hamburger-icon span {
  background: linear-gradient(135deg, #67c23a 0%, #409eff 100%);
  box-shadow: 0 0 15px rgba(103, 194, 58, 0.8);
}

/* 移动端菜单（纯HTML实现） */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: auto;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: linear-gradient(135deg, #0a1128 0%, #0f172a 100%);
  z-index: 9999;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.3), 0 0 30px rgba(64, 158, 255, 0.1);
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  pointer-events: auto;
}

.mobile-menu.active {
  transform: translateX(0);
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #0a1128 0%, #0f172a 100%);
  border-bottom: 1px solid rgba(64, 158, 255, 0.2);
}

.mobile-menu-title {
  color: #fff;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
  margin: 0;
}

.mobile-menu-close {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(64, 158, 255, 0.2);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-menu-close:hover {
  background-color: rgba(64, 158, 255, 0.4);
  transform: rotate(90deg);
}

.mobile-menu-close i {
  color: #409eff;
  font-size: 18px;
}

/* 移动端菜单列表 */
.mobile-menu-list {
  width: 100%;
  padding: 10px 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  margin: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 16px;
  position: relative;
  overflow: hidden;
}

.mobile-menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.1) 0%, rgba(103, 194, 58, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 0;
}

.mobile-menu-item:hover::before {
  opacity: 1;
}

.mobile-menu-item:hover {
  background-color: rgba(64, 158, 255, 0.1) !important;
  color: #409eff !important;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3), inset 0 0 20px rgba(64, 158, 255, 0.1);
  transform: translateX(-5px);
}

.mobile-menu-item.active {
  background-color: rgba(64, 158, 255, 0.2) !important;
  color: #409eff !important;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.4), inset 0 0 20px rgba(64, 158, 255, 0.2);
}

.mobile-menu-item i {
  margin-right: 15px;
  font-size: 18px;
  z-index: 1;
  position: relative;
}

.mobile-menu-item span {
  z-index: 1;
  position: relative;
}

/* 动画效果 */
@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.8;
  }
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

@keyframes textGlow {
  from {
    text-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
  }
  to {
    text-shadow: 0 0 20px rgba(64, 158, 255, 0.8), 0 0 30px rgba(103, 194, 58, 0.5);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (min-width: 769px) {
  .mobile-menu-container {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .nav-container {
    display: none !important;
  }

  .logo-text {
    font-size: 1rem;
  }

  .logo {
    width: 52px !important;
    height: 47px !important;
  }

  .tech-header {
    height: 64px;
  }

  .header-content {
    height: 64px;
  }
}

/* 确保移动端菜单按钮在PC端完全隐藏 */
.mobile-menu-container {
  display: none;
}

@media (max-width: 768px) {
  .mobile-menu-container {
    display: flex !important;
  }
}
</style>
